import { render, staticRenderFns } from "./ItemGroupList.vue?vue&type=template&id=1a6cc460&scoped=true&"
import script from "./ItemGroupList.vue?vue&type=script&lang=ts&"
export * from "./ItemGroupList.vue?vue&type=script&lang=ts&"
import style0 from "./ItemGroupList.vue?vue&type=style&index=0&id=1a6cc460&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6cc460",
  null
  
)

export default component.exports